import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProjectsList from "../../../common/components/Projects/ProjectsScroll";


const ProjectsSection = ({ projects, lang }) => {

    return (
        <>
            {projects?.length > 0 && <>
                <div className="py-6">
                    <div className="container text-center translate-dynamic">
                        <div className="mb-5 center mw-800px font-etihad color-secondary">
                            <h3 className="color-secondary">Support projects that fight<br />climate change</h3>
                            <p style={{ fontSize: '1.25rem' }}>Climate Friendly Traveller supports only the highest quality carbon offsetting projects around the world, to bring you peace of mind and results.</p>
                        </div>
                        <div className="projects-section font-etihad-important color-secondary text-align-start img-rounded white-project-basket mobile-text-center">
                            <ProjectsList title={null} projects={projects} lang={lang} />
                        </div>
                    </div>
                </div>
            </>}
        </>
    )
}


export default ProjectsSection;